import * as firebase from 'firebase';
import { History } from 'history';
import { BaseComponent, BaseComponentState } from '../base/BaseComponent';
import { HotelBedCatalogData, HotelBedData } from '../shared/index';
import { HotelRequestCheckerTool } from './HotelRequestCheckerTool';
import { HotelsLeftSide } from './HotelsLeftSide';
import { HotelsMainContentWithBulkData } from './HotelsMainContentWithBulkData';

import { FirebaseRealtimeDbBasedHotelRequestCheckerTool } from './req-available/FirebaseRealtimeDbBasedHotelRequestCheckerTool' ;
export type REQ_AVAILABLE_PANEL_STATE = 'INITIAL_CHECKING' | 'ERROR' | 'CHECKING_WITH_NO_DATA_READY' | 'CHECKING_WITH_SOME_DATA_READY' | 'COMPLETE_CHECKING';
export const PAGE_SIZE: number = 15;
export interface BaseHaveHotelSearchPanelProps {
    lang: string;
    currency: string;
    history: History;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    /**
     * real time database ref
     */
    realtimeDb: firebase.database.Database;
    /**
     * req key dari request
     */
    responKey: string;
    /**
     * ini kalau check path di kirimkan dari HTTP request untuk req available
     */
    reqAvailableCheckPath?: string ; 
    uuid: string;
    firestoreDb: firebase.firestore.Firestore;
    fromSlug?: string;
    slugData?: string;
}
export interface BaseHaveHotelSearchPanelState extends BaseComponentState {

    /** 
     * filter data current
     */
    currentFilter: HotelBedData.SearchFilter;
    errorMessage: string | JSX.Element;

    hotelCodes: number[];
    /**
     * untuk did catch
     */
    haveRenderError?: boolean;
    /**
     * data category di index
     */
    indexedCategoryData: { [id: string]: HotelBedCatalogData.Category };
    filterRate: {
        maxRate: number,
        minRate: number
    };
    leftPanelRequesting: string;
    requestHeader: HotelBedCatalogData.ReqHotelAvailable;
    /**
     * status dari panel. 
     * <ol>
     * <li>CHECKING: ini cek ke database, untuk status header. </li>
     * <li>DATA_READY_TO_DISPLAY: status code = 'AVAILABLE','PARTIALY-AVAILABLE','COMPLETE-WITH-ERROR'</li>
     * <li>RUNNING_AVALIBILITY_REQUEST: request ke hotelbed sedang berjalan</li>
     * <li>ERROR: ada error</li>
     * <li>NOTAVAILABLE: no available sama sekali</li>
     * </ol>
     */
    panelState: REQ_AVAILABLE_PANEL_STATE;
    /**
     * marker penanda ada change pada panel search. misal category menerima data
     */
    version: number;
    /**
     * flag panel sedang request atau tidak
     */
    requesting: boolean;

    totalRow: number;

    order: string;
    orderAsc: string;
}

/**
 * base class untuk panel dengan search hotel
 */
export abstract class BaseHaveHotelSearchPanel<PROPS extends BaseHaveHotelSearchPanelProps, STATE extends BaseHaveHotelSearchPanelState> extends BaseComponent<PROPS, STATE> {
    getAvailabilityDetail(): any {
        throw new Error("Method not implemented.");
    }
    /**
     * checker request header
     */
    checkerRequestAvailable: HotelRequestCheckerTool;
    /**
     * panel sisi kiri
     */
    leftSidePanel: HotelsLeftSide;
    /**
     * Panel untuk list hotels
     */
    hotelMainPanel: HotelsMainContentWithBulkData;
    constructor(props: PROPS) {
        super(props);
        this.checkerRequestAvailable = new FirebaseRealtimeDbBasedHotelRequestCheckerTool({
            realtimeDb: this.props.realtimeDb,
            checkPath: this.props.reqAvailableCheckPath , 
            // firestoreDb: this.props.firestoreDb,
            uuid: this.props.uuid,
            onCheckComplete: (requestHeader: HotelBedCatalogData.ReqHotelAvailable) => {
                //
                this.setStateHelperAsync(st => {
                    st.requestHeader = requestHeader;
                    st.panelState = 'COMPLETE_CHECKING';
                    st.requesting = false;
                    st.totalRow = requestHeader.detailCount!;
                }).then(d => {
                    //
                    this.hotelMainPanel.updatePanelState(this.state.panelState);
                    this.hotelMainPanel.onChangePage(0, " BaseHaveHotelSearchPanel onCheckComplete");
                });
                if (this.leftSidePanel) {
                    this.leftSidePanel.getData();
                }
            },
            onCheckResultError: (exc: any) => {
                this.setStateHelper(st => {
                    st.panelState = 'ERROR';
                    st.requesting = false;
                    this.hotelMainPanel.updatePanelState("ERROR");
                    st.errorMessage = exc.messsage;
                });
                if (this.leftSidePanel) {
                    this.leftSidePanel.getData();
                }
            },
            onRequestHeaderDataChange: (requestHeader: HotelBedCatalogData.ReqHotelAvailable) => {
                this.setStateHelperAsync(st => {
                    let reqFlag = true;
                    let sttsPanel: REQ_AVAILABLE_PANEL_STATE = 'CHECKING_WITH_NO_DATA_READY';
                    if (requestHeader.statusCode === 'AVAILABLE' || requestHeader.statusCode === 'NOTAVAILABLE' || requestHeader.statusCode === 'COMPLETE-WITH-ERROR') {
                        reqFlag = false;
                        sttsPanel = 'COMPLETE_CHECKING';
                    } else if (requestHeader.statusCode === 'PARTIALY-AVAILABLE') {
                        sttsPanel = 'CHECKING_WITH_SOME_DATA_READY';
                    }
                    st.panelState = sttsPanel;
                    st.requesting = reqFlag;
                    st.requestHeader = requestHeader;
                    st.totalRow = requestHeader.detailCount!;
                }).then(d => {
                    // 
                    if (this.hotelMainPanel) {
                        this.hotelMainPanel.updatePanelState(this.state.panelState);
                    }
                    // this.getAvailabilityDetail(true);
                    if (this.state.panelState === 'CHECKING_WITH_SOME_DATA_READY' || this.state.panelState === 'COMPLETE_CHECKING') {
                        this.hotelMainPanel.onChangePage(0, "BaseHaveHotelSearchPanel onRequestHeaderDataChange");
                    }

                    if (this.leftSideFilter && this.state.requestHeader && ['PARTIALY-AVAILABLE'].indexOf(this.state.requestHeader.statusCode!) >= 0) {
                        this.leftSidePanel.getData();
                    }
                });
            }

        });
        this.state = this.generateState();
    }
    /**
     * generate State
     */
    protected abstract generateState(): STATE;
    protected leftSideFilter: (externalFilter: HotelBedData.ExternalFilter) => any = (externalFilter: HotelBedData.ExternalFilter) => {
        this.props.getHotels(this.props.lang, 1, 15, this.state.currentFilter, externalFilter);
    }
}



// WEBPACK FOOTER //
// ./src/hotels/BaseHaveHotelSearchPanel.tsx